export default "__VITE_ASSET__cf25be8d__"